"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitCollmise = exports.collmise = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-params */
/* eslint-disable max-lines-per-function */
const collmise = (options = {}) => {
    return collmiseHelper(Object.assign({}, options), {
        collectors: [],
        req: {
            currentlyRunningPromises: {},
            promisesResponses: {},
            queue: { keySet: new Set(), singles: [] },
        },
    });
};
exports.collmise = collmise;
const collmiseHelper = (options, inner) => {
    return {
        addCollector: (collector) => {
            return collmiseHelper(options, Object.assign(Object.assign({}, inner), { collectors: removeDublicateCollectors([
                    ...inner.collectors,
                    normalizeCollectorInfo({
                        visible: true,
                        collector: Object.assign({}, collector),
                    }),
                ]) }));
        },
        addInvisibleCollector: (collector) => {
            return collmiseHelper(options, Object.assign(Object.assign({}, inner), { collectors: [
                    ...inner.collectors,
                    normalizeCollectorInfo({
                        visible: false,
                        collector: Object.assign({}, collector),
                    }),
                ] }));
        },
        collectors: getCollectors(options, inner),
        on: getOnFn(options, inner),
    };
};
const normalizeCollectorInfo = (info) => {
    if (!info.collector.splitInIdClusters && !info.collector.clusterToIds) {
        info.collector.splitInIdClusters = ids => [{ cluster: ids, ids }];
        info.collector.clusterToIds = ids => ids;
    }
    return info;
};
const removeDublicateCollectors = (collectors) => {
    const names = new Set();
    const reverseCollectors = [];
    for (let i = collectors.length - 1; i >= 0; --i) {
        const each = collectors[i];
        if (each.visible === true && names.has(each.collector.name))
            continue;
        reverseCollectors.push(each);
    }
    return reverseCollectors.reverse();
};
function isNonEmptyData(value) {
    if (value === undefined || value === null)
        return false;
    return true;
}
const getOnFn = (options, inner) => {
    return (id) => {
        const cacheOptions = value => {
            return getOnFn(options, typeof value === "object" && value !== null
                ? Object.assign(Object.assign({}, inner), { _passedCacheOptions: Object.assign(Object.assign({}, inner._passedCacheOptions), value) }) : inner)(id);
        };
        const fresh = (...args) => {
            const value = normalizeArgBoolean(args);
            return getOnFn(options, typeof value === "boolean"
                ? Object.assign(Object.assign({}, inner), { useFresh: value }) : inner)(id);
        };
        const request = getSingleRequest(id, options, inner, false);
        const submitToCollectors = getSingleRequest(id, options, inner, true);
        return {
            cacheOptions,
            fresh,
            request,
            requestAs: request,
            submitToCollectors: submitToCollectors,
        };
    };
};
const serializeId = (id, options) => {
    if (options.serializeId)
        return options.serializeId(id);
    if (typeof id === "string" || typeof id === "number")
        return id + "";
    if (typeof id === "object" &&
        id !== null &&
        id.hasOwnProperty("toString") &&
        typeof id.toString === "function") {
        return id.toString();
    }
    return JSON.stringify(id);
};
const getCacheOrFoundPromiseOnKey = async (id, options, inner) => {
    const isNotEmpty = options.isNonEmptyData || isNonEmptyData;
    const cacheOptions = getCacheOptions(options, inner);
    if (cacheOptions.useCache && typeof options.findCachedData === "function") {
        const cachedData = await options.findCachedData(id);
        if (isNotEmpty(cachedData)) {
            return {
                hasFoundData: true,
                promise: cachedData,
            };
        }
    }
    const key = serializeId(id, options);
    const result = getFoundPromiseOnKey(key, cacheOptions, inner);
    if (result) {
        return {
            hasFoundData: true,
            promise: result.promise,
        };
    }
    return {
        hasFoundData: false,
    };
};
const getFoundPromiseOnKey = (key, cacheOptions, inner) => {
    if (cacheOptions.joinConcurrentRequests &&
        inner.req.currentlyRunningPromises[key]) {
        return inner.req.currentlyRunningPromises[key];
    }
    if (cacheOptions.useResponseCache && inner.req.promisesResponses[key]) {
        return inner.req.promisesResponses[key];
    }
    return null;
};
const addInQueue = (item, options, inner) => {
    const { id, key, hasFoundData, skipCallingOne } = item;
    let insertNew = false;
    const containsSameId = inner.req.queue.keySet.has(key);
    if (options.consistentDataOnSameIds === false || !containsSameId) {
        insertNew = true;
    }
    else if (containsSameId) {
        const found = inner.req.queue.singles.find(e => {
            if (e.key !== key)
                return false;
            if (skipCallingOne && !e.skipCallingOne)
                return false;
            return true;
        });
        if (!found)
            insertNew = true;
    }
    if (insertNew) {
        inner.req.queue.keySet.add(key);
        inner.req.queue.singles.push({
            id,
            hasFoundData,
            key,
            skipCallingOne,
        });
    }
};
const getSingleRequest = (id, options, inner, skipCallingOne, isCallingMultipleRequired) => async (...args) => {
    const getPromise = args[0];
    if (!skipCallingOne && !getPromise) {
        throw new Error("Collmise: argument for request is required");
    }
    const key = serializeId(id, options);
    const dataTransformer = options.dataTransformer
        ? options.dataTransformer
        : rawData => rawData;
    const cacheOptions = getCacheOptions(options, inner);
    let hasFoundData = false;
    let foundedDataPromsie = undefined;
    if (!skipCallingOne) {
        const result = await getCacheOrFoundPromiseOnKey(id, options, inner);
        if (result.hasFoundData) {
            hasFoundData = true;
            foundedDataPromsie = result.promise;
        }
    }
    if (!isCallingMultipleRequired && hasFoundData) {
        return foundedDataPromsie;
    }
    const collectingTimeoutMS = typeof options.collectingTimeoutMS === "undefined"
        ? 1
        : options.collectingTimeoutMS;
    const hasCollectors = inner.collectors.length > 0;
    const queueItem = {
        id,
        hasFoundData,
        key,
        skipCallingOne,
    };
    addInQueue(queueItem, options, inner);
    if (collectingTimeoutMS > 0 && hasCollectors && !inner.req.delayPromise) {
        inner.req.delayPromise = getDelayPromise(collectingTimeoutMS, options, inner);
    }
    const result = await inner.req.delayPromise;
    let matchedQueues = [];
    if (result) {
        matchedQueues = result.queuedClusters.filter(e => e.keySet.has(key));
    }
    if (hasFoundData &&
        (matchedQueues.length === 0 ||
            matchedQueues.every(e => !e.collector.alwaysCallCollector))) {
        return foundedDataPromsie;
    }
    if (matchedQueues.length > 0 &&
        matchedQueues.some(e => e.hasOwnProperty("collectorPromise"))) {
        const collectorPromises = matchedQueues
            .filter(e => e.hasOwnProperty("collectorPromise"))
            .map(e => e.collectorPromise.then(manyData => (Object.assign(Object.assign({}, e), { manyData }))));
        const promiseResults = await Promise.all(collectorPromises);
        if (hasFoundData) {
            return foundedDataPromsie;
        }
        if (!options.alwaysCallDirectRequest) {
            const firstCollected = promiseResults.find(e => !!e.collector.findOne);
            if (firstCollected) {
                const oneData = firstCollected.collector.findOne(id, firstCollected.manyData);
                return transformFoundedOneData(id, oneData, options);
            }
        }
    }
    if (hasFoundData) {
        return foundedDataPromsie;
    }
    if (skipCallingOne) {
        throw new Error(`No gathering collector found for key ${key}`);
    }
    const promResult = getFoundPromiseOnKey(key, cacheOptions, inner);
    if (promResult) {
        return promResult.promise;
    }
    return sendSingle(id, options, dataTransformer, getPromise, inner, cacheOptions);
};
const getDelayPromise = (collectingTimeoutMS, options, inner) => {
    return new Promise(resolve => {
        setTimeout(() => {
            delete inner.req.delayPromise;
            const skipCallingsKeys = new Set(inner.req.queue.singles.filter(e => e.skipCallingOne).map(e => e.key));
            const uncached = inner.req.queue.singles.filter(e => !e.hasFoundData);
            const queuedClusters = [];
            for (const collectorInfo of inner.collectors) {
                const useAll = collectorInfo.collector.alwaysCallCollector === true;
                const singles = useAll ? inner.req.queue.singles : uncached;
                const singleIds = uniquelizeIds(singles.map(e => e.id), options);
                const clusteredIds = collectorInfo.collector.splitInIdClusters
                    ? collectorInfo.collector.splitInIdClusters(singleIds)
                    : [{ cluster: singleIds, ids: singleIds }];
                for (const clusterInfo of clusteredIds) {
                    if (clusterInfo.ids.length === 0)
                        continue;
                    const collectorRequest = getCollectorRequest(clusterInfo.cluster, collectorInfo, options, Object.assign(Object.assign({}, inner), { multiUseCache: false, disableSpreading: true, disableSavingSpreadPromises: true }));
                    const sendMultiRequest = !!(clusterInfo.ids.length > 1 ||
                        (clusterInfo.ids.length === 1 &&
                            skipCallingsKeys.has(serializeId(clusterInfo.ids[0], options))) ||
                        collectorInfo.collector.alwaysCallCollector);
                    const collectorPromise = sendMultiRequest
                        ? collectorRequest()
                        : undefined;
                    if (collectorInfo.visible) {
                        const queued = {
                            cluster: clusterInfo.cluster,
                            collector: collectorInfo.collector,
                            collectorPromise,
                            ids: clusterInfo.ids,
                            keySet: new Set(clusterInfo.ids.map(id => serializeId(id, options))),
                        };
                        if (!sendMultiRequest)
                            delete queued.collectorPromise;
                        queuedClusters.push(queued);
                    }
                }
            }
            inner.req.queue = {
                keySet: new Set(),
                singles: [],
            };
            resolve({ queuedClusters });
        }, collectingTimeoutMS);
    });
};
const uniquelizeIds = (ids, options) => {
    if (options.consistentDataOnSameIds === false)
        return ids;
    const uniquelizedIds = [];
    const usedKeys = new Set();
    for (const id of ids) {
        const key = serializeId(id, options);
        if (usedKeys.has(key))
            continue;
        uniquelizedIds.push(id);
        usedKeys.add(key);
    }
    return uniquelizedIds;
};
const transformFoundedOneData = (id, oneData, options) => {
    const isNotEmpty = options.isNonEmptyData || isNonEmptyData;
    if (isNotEmpty(oneData)) {
        return oneData;
    }
    else {
        const getNotFoundError = options.getNotFoundError || defaultGetNotFoundError;
        throw getNotFoundError(id);
    }
};
const defaultGetNotFoundError = (id) => {
    return new Error(`id ${id} not found`);
};
const sendSingle = async (id, options, dataTransformer, getPromise, inner, cacheOptions) => {
    const promise = toPromise(getPromise(id)).then(d => dataTransformer(d, id));
    return saveSinglePromise(id, promise, options, inner, cacheOptions);
};
const saveSinglePromise = async (id, singlePromise, options, inner, cacheOptions) => {
    var _a;
    const key = serializeId(id, options);
    try {
        if (cacheOptions.cacheResponse) {
            inner.req.currentlyRunningPromises[key] = {
                promise: singlePromise,
            };
        }
        const data = await singlePromise;
        saveResponse(key, singlePromise, cacheOptions, options, inner);
        return data;
    }
    finally {
        if (((_a = inner.req.currentlyRunningPromises[key]) === null || _a === void 0 ? void 0 : _a.promise) === singlePromise) {
            delete inner.req.currentlyRunningPromises[key];
        }
    }
};
const saveResponse = (key, promise, cacheOptions, options, inner) => {
    const responseCacheTimeoutMS = options.responseCacheTimeoutMS || 0;
    if (cacheOptions.cacheResponse && responseCacheTimeoutMS > 0) {
        inner.req.promisesResponses[key] = {
            promise: promise,
        };
        setTimeout(() => {
            if (inner.req.promisesResponses[key] &&
                inner.req.promisesResponses[key].promise === promise) {
                delete inner.req.promisesResponses[key];
            }
        }, responseCacheTimeoutMS);
    }
};
const toPromise = (value) => {
    return Promise.resolve(value);
};
const getCollectors = (options, inner) => {
    const collectors = {};
    for (const each of inner.collectors) {
        if (!each.visible)
            continue;
        collectors[each.collector.name] = getCollectorFn(each.collector.name, options, inner);
    }
    return collectors;
};
const normalizeArgBoolean = (args) => {
    if (args.length === 0)
        return true;
    return args[0];
};
const getCollectorFn = (name, options, inner) => {
    const getFn = (idCluster) => {
        const fresh = (...args) => {
            const value = normalizeArgBoolean(args);
            if (value === null || value === undefined)
                return getFn(idCluster);
            return getCollectorFn(name, options, Object.assign(Object.assign({}, inner), { multiUseFresh: value }))(idCluster);
        };
        const useCache = (...args) => {
            const value = normalizeArgBoolean(args);
            if (value === null || value === undefined)
                return getFn(idCluster);
            return getCollectorFn(name, options, Object.assign(Object.assign({}, inner), { multiUseCache: value }))(idCluster);
        };
        const collectorInfo = inner.collectors.find(e => e.visible === true && e.collector.name === name);
        const request = getCollectorRequest(idCluster, collectorInfo, options, inner);
        return {
            useCache,
            fresh,
            request,
            requestAs: request,
        };
    };
    return getFn;
};
const getCollectorRequest = (idCluster, collectorInfo, options, inner) => {
    const mainFn = (getForClaster) => {
        let useCache = true;
        if (!options.findCachedData)
            useCache = false;
        if (options.useCache === false)
            useCache = false;
        if (inner.multiUseCache === false)
            useCache = false;
        if (inner.multiUseFresh === true)
            useCache = false;
        /* if (
          inner.useFresh &&
          inner._passedCacheOptions &&
          inner._passedCacheOptions.useCache === false
        ) {
          useCache = false;
        } */
        const dataTransformer = options.dataTransformer
            ? options.dataTransformer
            : rawData => rawData;
        const isNotEmpty = options.isNonEmptyData || isNonEmptyData;
        const mainLogic = () => {
            const spread = !inner.disableSpreading && !getForClaster;
            if (spread &&
                collectorInfo.collector.splitInIdClusters &&
                collectorInfo.collector.clusterToIds &&
                collectorInfo.collector.mergeOnData) {
                const copiedInner = Object.assign({}, inner);
                if (typeof inner.multiUseCache === "boolean") {
                    inner._passedCacheOptions = Object.assign(Object.assign({}, inner._passedCacheOptions), { useCache: inner.multiUseCache });
                }
                const ids = collectorInfo.collector.clusterToIds(idCluster);
                const allPromises = ids.map(id => getSingleRequest(id, options, copiedInner, true, true)(() => Promise.reject("fake function")));
                const getAll = Promise.all(allPromises);
                const mainPromise = getAll.then(allData => collectorInfo.collector.mergeOnData(undefined, allData.map((data, index) => ({ data, id: ids[index] }))));
                return { mainPromise, waiter: getAll.then() };
            }
            const fetchedDataPromise = toPromise(getForClaster
                ? getForClaster(idCluster)
                : collectorInfo.collector.onRequest(idCluster));
            const mainPromise = fetchedDataPromise.then(async (fetchedData) => {
                const multiDataTransformer = collectorInfo.collector
                    .multiDataTransformer;
                let finalData;
                if (collectorInfo.visible && multiDataTransformer) {
                    finalData = await multiDataTransformer(fetchedData, idCluster);
                }
                else
                    finalData = fetchedData;
                return finalData;
            });
            return { mainPromise, waiter: Promise.resolve() };
        };
        if (useCache &&
            collectorInfo.collector.splitInIdClusters &&
            collectorInfo.collector.clusterToIds &&
            collectorInfo.collector.mergeOnData &&
            options.findCachedData) {
            const ids = collectorInfo.collector.clusterToIds(idCluster);
            const cachedPromises = ids.map(id => toPromise(options.findCachedData(id)));
            const mainPromise = stickyPromise();
            const waiterPromise = stickyPromise();
            const topPromise = Promise.all(cachedPromises).then(cachedData => {
                const cacheOptions = getCacheOptions(options, inner);
                const results = cachedData.map((data, index) => {
                    const empty = !isNotEmpty(data);
                    if (empty) {
                        const key = serializeId(ids[index], options);
                        const singleResult = getFoundPromiseOnKey(key, cacheOptions, inner);
                        if (!singleResult) {
                            return { empty: true, index, id: ids[index] };
                        }
                        return {
                            empty: false,
                            isPromise: true,
                            data: singleResult.promise,
                            index,
                            id: ids[index],
                        };
                    }
                    return {
                        empty: false,
                        isPromise: false,
                        data: dataTransformer(data, ids[index]),
                        index,
                        id: ids[index],
                    };
                });
                const hasFoundAtLeasOne = results.some(e => !e.empty);
                if (hasFoundAtLeasOne) {
                    const notFoundIds = results.filter(e => e.empty).map(e => e.id);
                    let manyData = undefined;
                    const successfullyCachedData = results
                        .filter(e => !e.empty)
                        .map(e => new Promise((resolve, reject) => {
                        toPromise(e.data)
                            .then(data => resolve({ id: e.id, data }))
                            .catch(reject);
                    }));
                    const successfullyCachedDataPromise = Promise.all(successfullyCachedData);
                    waiterPromise.attach(successfullyCachedDataPromise);
                    successfullyCachedDataPromise.then().catch();
                    const fn = async () => {
                        if (notFoundIds.length > 0) {
                            const clustersInfo = collectorInfo.collector.splitInIdClusters(notFoundIds);
                            if (clustersInfo.length !== 1) {
                                throw new Error("excpected tu return exactly one cluster for ids " +
                                    notFoundIds);
                            }
                            const newCluster = clustersInfo[0].cluster;
                            manyData = await getCollectorRequest(newCluster, collectorInfo, options, Object.assign(Object.assign({}, inner), { multiUseCache: false, disableSavingSpreadPromises: true }))(getForClaster);
                        }
                        return collectorInfo.collector.mergeOnData(manyData, await successfullyCachedDataPromise);
                    };
                    const finalResult = fn();
                    waiterPromise.attach(finalResult);
                    mainPromise.attach(finalResult);
                }
                else {
                    const res = mainLogic();
                    mainPromise.attach(res.mainPromise);
                    waiterPromise.attach(res.waiter);
                }
            });
            mainPromise.attachCatch(topPromise);
            waiterPromise.attachCatch(topPromise);
            return { mainPromise, waiter: waiterPromise };
        }
        return mainLogic();
    };
    return (getForClaster) => {
        const { mainPromise, waiter } = mainFn(getForClaster);
        waiter
            .then(() => saveManySingleRequests(mainPromise, idCluster, collectorInfo, options, inner))
            .catch(() => {
            //
        });
        return mainPromise;
    };
};
const stickyPromise = () => {
    let final = null;
    const helper = {
        resolve: (data) => {
            if (!final)
                final = { data, resolved: true };
        },
        reject: (error) => {
            if (!final)
                final = { data: error, resolved: false };
        },
    };
    const promise = new Promise((resolve, reject) => {
        if (final) {
            if (final.resolved)
                resolve(final.data);
            else
                reject(final.data);
        }
        helper.resolve = resolve;
        helper.reject = reject;
    });
    return Object.assign(promise, helper, {
        attach: (prom) => {
            prom.then(helper.resolve).catch(helper.reject);
        },
        attachCatch: (prom) => {
            prom.catch(helper.reject);
        },
    });
};
const saveManySingleRequests = (promise, idCluster, collectorInfo, options, inner) => {
    if (!inner.disableSavingSpreadPromises &&
        collectorInfo.visible === true &&
        collectorInfo.collector.clusterToIds &&
        collectorInfo.collector.findOne) {
        const ids = collectorInfo.collector.clusterToIds(idCluster);
        const cacheOptions = getCacheOptions(options, inner);
        for (const id of ids) {
            const singlePromise = promise.then(manyData => {
                return transformFoundedOneData(id, collectorInfo.collector.findOne(id, manyData), options);
            });
            saveSinglePromise(id, singlePromise, options, inner, cacheOptions).catch(() => { });
        }
    }
};
const getCacheOptions = (options, inner, getPureCacheOptions) => {
    if (options.consistentDataOnSameIds === false) {
        return {
            joinConcurrentRequests: false,
            useCache: false,
            useResponseCache: false,
            cacheResponse: false,
        };
    }
    if (!getPureCacheOptions && inner.useFresh) {
        return getFreshOptions(options);
    }
    return Object.assign({ useCache: typeof options.useCache === "boolean"
            ? options.useCache
            : !!options.findCachedData, useResponseCache: typeof options.responseCacheTimeoutMS === "number" &&
            options.responseCacheTimeoutMS > 0, joinConcurrentRequests: typeof options.joinConcurrentRequests === "boolean"
            ? options.joinConcurrentRequests
            : true, cacheResponse: true }, removeUndefinedValues(inner._passedCacheOptions || {}));
};
const getFreshOptions = (options) => {
    return Object.assign({ joinConcurrentRequests: typeof options.joinConcurrentRequests === "boolean"
            ? options.joinConcurrentRequests
            : true, useCache: false, useResponseCache: false, cacheResponse: true }, removeUndefinedValues(options.freshRequestOptions || {}));
};
function removeUndefinedValues(obj) {
    const obj2 = Object.assign({}, obj);
    const keys = Object.keys(obj);
    for (const key of keys) {
        if (obj2[key] === undefined) {
            delete obj2[key];
        }
    }
    return obj2;
}
const unitCollmise = (options = {}) => {
    return unitCollmiseHelper(options);
};
exports.unitCollmise = unitCollmise;
const unitDefaultId = Symbol("unitCollmiseDefaultId");
const unitCollmiseHelper = (options) => {
    const op = exports.collmise(options || {});
    return op.on(unitDefaultId);
};
